"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkOrderApi = exports.WorkOrderApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
// @ts-ignore
const models_1 = require("../models");
// @ts-ignore
const models_2 = require("../models");
// @ts-ignore
const models_3 = require("../models");
// @ts-ignore
const models_4 = require("../models");
// @ts-ignore
const models_5 = require("../models");
/**
 * WorkOrderApi - axios parameter creator
 * @export
 */
const WorkOrderApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} workOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelWorkOrder: async (workOrderId, options = {}) => {
            // verify required parameter 'workOrderId' is not null or undefined
            (0, common_1.assertParamExists)('cancelWorkOrder', 'workOrderId', workOrderId);
            const localVarPath = `/api/work-order/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (workOrderId !== undefined) {
                localVarQueryParameter['work_order_id'] = workOrderId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} workOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadWorkOrder: async (workOrderId, options = {}) => {
            // verify required parameter 'workOrderId' is not null or undefined
            (0, common_1.assertParamExists)('downloadWorkOrder', 'workOrderId', workOrderId);
            const localVarPath = `/api/work-order/{workOrderId}.pdf`
                .replace(`{${"workOrderId"}}`, encodeURIComponent(String(workOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {IWorkOrderEntity} iWorkOrderEntity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishWorkOrder: async (iWorkOrderEntity, options = {}) => {
            // verify required parameter 'iWorkOrderEntity' is not null or undefined
            (0, common_1.assertParamExists)('finishWorkOrder', 'iWorkOrderEntity', iWorkOrderEntity);
            const localVarPath = `/api/work-order/finish-work-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iWorkOrderEntity, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} workOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkOrder: async (workOrderId, options = {}) => {
            // verify required parameter 'workOrderId' is not null or undefined
            (0, common_1.assertParamExists)('getWorkOrder', 'workOrderId', workOrderId);
            const localVarPath = `/api/work-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (workOrderId !== undefined) {
                localVarQueryParameter['workOrderId'] = workOrderId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {boolean} [includeUsage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkOrderChecklists: async (includeUsage, options = {}) => {
            const localVarPath = `/api/work-order/checklists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (includeUsage !== undefined) {
                localVarQueryParameter['include_usage'] = includeUsage;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {InlineObject10} inlineObject10
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkOrderListPost: async (inlineObject10, options = {}) => {
            // verify required parameter 'inlineObject10' is not null or undefined
            (0, common_1.assertParamExists)('getWorkOrderListPost', 'inlineObject10', inlineObject10);
            const localVarPath = `/api/work-order/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject10, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [fromCreatedDate]
         * @param {string} [toCreatedDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkOrderStatusTotals: async (fromCreatedDate, toCreatedDate, options = {}) => {
            const localVarPath = `/api/work-order/status-totals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (fromCreatedDate !== undefined) {
                localVarQueryParameter['from_created_date'] = (fromCreatedDate instanceof Date) ?
                    fromCreatedDate.toISOString() :
                    fromCreatedDate;
            }
            if (toCreatedDate !== undefined) {
                localVarQueryParameter['to_created_date'] = (toCreatedDate instanceof Date) ?
                    toCreatedDate.toISOString() :
                    toCreatedDate;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {boolean} [includeInactive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkOrderTypes: async (includeInactive, options = {}) => {
            const localVarPath = `/api/work-order/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (includeInactive !== undefined) {
                localVarQueryParameter['include_inactive'] = includeInactive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} planningItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkOrdersFromPlanningItem: async (planningItemId, options = {}) => {
            // verify required parameter 'planningItemId' is not null or undefined
            (0, common_1.assertParamExists)('getWorkOrdersFromPlanningItem', 'planningItemId', planningItemId);
            const localVarPath = `/api/work-order/work-orders-from-planning-item`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (planningItemId !== undefined) {
                localVarQueryParameter['planningItemId'] = planningItemId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {IWorkOrderEntity} iWorkOrderEntity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceWorkOrder: async (iWorkOrderEntity, options = {}) => {
            // verify required parameter 'iWorkOrderEntity' is not null or undefined
            (0, common_1.assertParamExists)('invoiceWorkOrder', 'iWorkOrderEntity', iWorkOrderEntity);
            const localVarPath = `/api/work-order/invoice-work-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iWorkOrderEntity, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {IWorkOrderEntity} iWorkOrderEntity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertWorkOrder: async (iWorkOrderEntity, options = {}) => {
            // verify required parameter 'iWorkOrderEntity' is not null or undefined
            (0, common_1.assertParamExists)('upsertWorkOrder', 'iWorkOrderEntity', iWorkOrderEntity);
            const localVarPath = `/api/work-order/upsert-work-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iWorkOrderEntity, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.WorkOrderApiAxiosParamCreator = WorkOrderApiAxiosParamCreator;
/**
 * WorkOrderApi -
 */
var WorkOrderApi;
(function (WorkOrderApi) {
    /**
     *
     * @param {number} workOrderId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof WorkOrderApi
     * url /api/work-order/cancel
     */
    async function cancelWorkOrder(workOrderId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.WorkOrderApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.cancelWorkOrder(workOrderId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            return res;
        });
    }
    WorkOrderApi.cancelWorkOrder = cancelWorkOrder;
    /**
     *
     * @param {number} workOrderId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof WorkOrderApi
     * url /api/work-order/{workOrderId}.pdf
     */
    async function downloadWorkOrder(workOrderId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.WorkOrderApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.downloadWorkOrder(workOrderId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            return res;
        });
    }
    WorkOrderApi.downloadWorkOrder = downloadWorkOrder;
    /**
     *
     * @param {IWorkOrderEntity} iWorkOrderEntity
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof WorkOrderApi
     * url /api/work-order/finish-work-order
     */
    async function finishWorkOrder(iWorkOrderEntity, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.WorkOrderApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.finishWorkOrder(iWorkOrderEntity, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_3.parseIWorkOrderEntity)(res.data);
            return res;
        });
    }
    WorkOrderApi.finishWorkOrder = finishWorkOrder;
    /**
     *
     * @param {number} workOrderId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof WorkOrderApi
     * url /api/work-order
     */
    async function getWorkOrder(workOrderId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.WorkOrderApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkOrder(workOrderId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_3.parseIWorkOrderEntity)(res.data);
            return res;
        });
    }
    WorkOrderApi.getWorkOrder = getWorkOrder;
    /**
     *
     * @param {boolean} [includeUsage]
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof WorkOrderApi
     * url /api/work-order/checklists
     */
    async function getWorkOrderChecklists(includeUsage, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.WorkOrderApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkOrderChecklists(includeUsage, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_2.parseIWorkOrderChecklistEntity)(x));
            return res;
        });
    }
    WorkOrderApi.getWorkOrderChecklists = getWorkOrderChecklists;
    /**
     *
     * @param {InlineObject10} inlineObject10
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof WorkOrderApi
     * url /api/work-order/list
     */
    async function getWorkOrderListPost(inlineObject10, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.WorkOrderApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkOrderListPost(inlineObject10, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_1.parseBatchResponseIWorkOrderEntity)(res.data);
            return res;
        });
    }
    WorkOrderApi.getWorkOrderListPost = getWorkOrderListPost;
    /**
     *
     * @param {string} [fromCreatedDate]
     * @param {string} [toCreatedDate]
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof WorkOrderApi
     * url /api/work-order/status-totals
     */
    async function getWorkOrderStatusTotals(fromCreatedDate, toCreatedDate, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.WorkOrderApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkOrderStatusTotals(fromCreatedDate, toCreatedDate, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_4.parseIWorkOrderStatusTotalsRow)(x));
            return res;
        });
    }
    WorkOrderApi.getWorkOrderStatusTotals = getWorkOrderStatusTotals;
    /**
     *
     * @param {boolean} [includeInactive]
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof WorkOrderApi
     * url /api/work-order/types
     */
    async function getWorkOrderTypes(includeInactive, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.WorkOrderApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkOrderTypes(includeInactive, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_5.parseIWorkOrderTypeEntity)(x));
            return res;
        });
    }
    WorkOrderApi.getWorkOrderTypes = getWorkOrderTypes;
    /**
     *
     * @param {number} planningItemId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof WorkOrderApi
     * url /api/work-order/work-orders-from-planning-item
     */
    async function getWorkOrdersFromPlanningItem(planningItemId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.WorkOrderApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkOrdersFromPlanningItem(planningItemId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_3.parseIWorkOrderEntity)(x));
            return res;
        });
    }
    WorkOrderApi.getWorkOrdersFromPlanningItem = getWorkOrdersFromPlanningItem;
    /**
     *
     * @param {IWorkOrderEntity} iWorkOrderEntity
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof WorkOrderApi
     * url /api/work-order/invoice-work-order
     */
    async function invoiceWorkOrder(iWorkOrderEntity, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.WorkOrderApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceWorkOrder(iWorkOrderEntity, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_3.parseIWorkOrderEntity)(res.data);
            return res;
        });
    }
    WorkOrderApi.invoiceWorkOrder = invoiceWorkOrder;
    /**
     *
     * @param {IWorkOrderEntity} iWorkOrderEntity
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof WorkOrderApi
     * url /api/work-order/upsert-work-order
     */
    async function upsertWorkOrder(iWorkOrderEntity, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.WorkOrderApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.upsertWorkOrder(iWorkOrderEntity, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_3.parseIWorkOrderEntity)(res.data);
            return res;
        });
    }
    WorkOrderApi.upsertWorkOrder = upsertWorkOrder;
})(WorkOrderApi || (exports.WorkOrderApi = WorkOrderApi = {}));
